<template>
  <div class="row">
    <div class="col-md-12">
      <dashboard-box :back="true" back-component-name="management.users.index">
        <template v-slot:title>
          <span>{{ $t("users.self") }}</span>
        </template>
        <template v-slot:preview>
          <b-row>
            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('users.name')">
                <b-form-input
                  v-model="form.name"
                  :placeholder="$t('users.name')"
                  :state="validateState('name')"
                  class="form-control form-control-solid"
                  name="name"
                  type="text"
                ></b-form-input>
                <b-form-invalid-feedback
                  v-if="!validateState('name') && !$v.form.name.required"
                  :state="validateState('name') && $v.form.name.required"
                >
                  {{ $t("users.validations.name.required") }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('users.surname')">
                <b-form-input
                  v-model="form.surname"
                  :placeholder="$t('users.surname')"
                  :state="validateState('surname')"
                  class="form-control form-control-solid"
                  name="surname"
                  type="text"
                ></b-form-input>
                <b-form-invalid-feedback
                  v-if="!validateState('surname') && !$v.form.surname.required"
                  :state="validateState('surname') && $v.form.surname.required"
                >
                  {{ $t("users.validations.surname.required") }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('users.title')">
                <b-form-input
                  v-model="form.title"
                  :placeholder="$t('users.title')"
                  :state="validateState('title')"
                  class="form-control form-control-solid"
                  name="title"
                  type="text"
                ></b-form-input>
                <b-form-invalid-feedback
                  v-if="!validateState('title') && !$v.form.title.required"
                  :state="validateState('title') && $v.form.title.required"
                >
                  {{ $t("users.validations.title.required") }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('users.email')">
                <b-form-input
                  v-model="form.email"
                  :placeholder="$t('users.email')"
                  :state="validateState('email')"
                  class="form-control form-control-solid"
                  name="email"
                  type="email"
                ></b-form-input>
                <b-form-invalid-feedback
                  v-if="!validateState('email') && !$v.form.email.required"
                  :state="validateState('email') && $v.form.email.required"
                >
                  {{ $t("users.validations.email.required") }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('users.password')">
                <b-form-input
                  v-model="form.password"
                  :placeholder="$t('users.password')"
                  :state="validateState('password')"
                  class="form-control form-control-solid"
                  name="password"
                  type="password"
                ></b-form-input>

                <b-form-invalid-feedback
                  v-if="
                    !validateState('password') && !$v.form.password.required
                  "
                  :state="
                    !(validateState('password') && !$v.form.password.required)
                  "
                >
                  {{ $t("users.validations.password.required") }}
                </b-form-invalid-feedback>

                <b-form-invalid-feedback
                  v-else-if="
                    !validateState('password') &&
                    !$v.form.password.passwordComplexity
                  "
                  :state="
                    !(
                      validateState('password') &&
                      !$v.form.password.passwordComplexity
                    )
                  "
                >
                  {{ $t("users.validations.password.passwordComplexity") }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('users.password_confirmation')">
                <b-form-input
                  v-model="form.password_confirmation"
                  :placeholder="$t('users.password_confirmation')"
                  :state="validateState('password_confirmation')"
                  class="form-control form-control-solid"
                  name="password_confirmation"
                  type="password"
                ></b-form-input>

                <b-form-invalid-feedback
                  v-if="
                    !validateState('password_confirmation') &&
                    !$v.form.password_confirmation.sameAsPassword
                  "
                  :state="
                    validateState('password_confirmation') &&
                    $v.form.password_confirmation.sameAsPassword
                  "
                >
                  {{ $t("users.validations.password_confirmation.same") }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('users.work_number')">
                <b-form-input
                  v-model="form.work_number"
                  :placeholder="$t('users.work_number')"
                  :state="validateState('work_number')"
                  class="form-control form-control-solid"
                  name="work_number"
                  type="text"
                ></b-form-input>
                <b-form-invalid-feedback
                  v-if="
                    !validateState('work_number') &&
                    !$v.form.work_number.required
                  "
                  :state="
                    validateState('work_number') && $v.form.work_number.required
                  "
                >
                  {{ $t("users.validations.work_number.required") }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('users.phone_number')">
                <b-form-input
                  v-model="form.phone_number"
                  :placeholder="$t('users.phone_number')"
                  :state="validateState('phone_number')"
                  class="form-control form-control-solid"
                  name="phone_number"
                  type="text"
                ></b-form-input>
                <b-form-invalid-feedback
                  v-if="
                    !validateState('phone_number') &&
                    !$v.form.phone_number.required
                  "
                  :state="
                    validateState('phone_number') &&
                    $v.form.phone_number.required
                  "
                >
                  {{ $t("users.validations.phone_number.required") }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col lg="6" md="6" sm="12" xl="6">
              <div class="form-group">
                <label>{{ $t("users.photo") }} </label>
                <div class="custom-file">
                  <input
                    type="file"
                    accept="image/*"
                    ref="user-photo"
                    @change="uploadFile($event)"
                    :state="validateState('photo')"
                    :placeholder="$t('general.select')"
                    class="custom-file-input"
                    id="inputGroupFile02"
                  />
                  <label class="custom-file-label" for="inputGroupFile02">{{
                    $t("general.select_option")
                  }}</label>
                </div>

                <b-form-invalid-feedback
                  v-if="!validateState('photo') && !$v.form.photo.required"
                  :state="validateState('photo') && $v.form.photo.required"
                >
                  {{ $t("users.validations.photo.required") }}
                </b-form-invalid-feedback>
              </div>
            </b-col>

            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('users.roles')">
                <multiple-select-input
                  :model.sync="form.role_id"
                  :values="roles"
                  :multiple="false"
                  label="name"
                  track-by="id"
                ></multiple-select-input>
                <b-form-invalid-feedback
                  v-if="!validateState('role_id') && !$v.form.role_id.required"
                  :state="validateState('role_id') && $v.form.role_id.required"
                >
                  {{ $t("users.validations.role.required") }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col
              lg="6"
              md="6"
              sm="12"
              xl="6"
              v-if="form.role_id && form.role_id === 3"
            >
              <b-form-group :label="$t('users.team_type')">
                <multiple-select-input
                  v-if="teamTypes && form.role_id && form.role_id === 3"
                  :model.sync="form.team_types"
                  :values="teamTypes"
                  :max="1"
                  :multiple="false"
                  label="name"
                  track-by="id"
                ></multiple-select-input>
                <b-form-invalid-feedback
                  v-if="
                    !validateState('team_types') && !$v.form.team_types.required
                  "
                  :state="
                    validateState('team_types') && $v.form.team_types.required
                  "
                >
                  {{ $t("users.validations.team_type.required") }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col
              lg="6"
              md="6"
              sm="12"
              xl="6"
              v-if="form.role_id && form.role_id === 3"
            >
              <b-form-group :label="$t('users.region')">
                <multiple-select-input
                  v-if="regions && form.role_id && form.role_id === 3"
                  :model.sync="form.regions"
                  :values="regions"
                  :multiple="false"
                  label="name"
                  track-by="id"
                ></multiple-select-input>
                <b-form-invalid-feedback
                  v-if="!validateState('regions') && !$v.form.regions.required"
                  :state="validateState('regions') && $v.form.regions.required"
                >
                  {{ $t("users.validations.region.required") }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col
              lg="6"
              md="6"
              sm="12"
              xl="6"
              v-if="form.role_id && form.role_id === 4"
            >
              <b-form-group :label="$t('users.institution')">
                <multiple-select-input
                  v-if="institutions && form.role_id && form.role_id === 4"
                  :model.sync="form.institutions"
                  :values="institutions"
                  :multiple="false"
                  :max="1"
                  label="name"
                  track-by="id"
                ></multiple-select-input>
                <b-form-invalid-feedback
                  v-if="
                    !validateState('institutions') &&
                    !$v.form.institutions.required
                  "
                  :state="
                    validateState('institutions') &&
                    $v.form.institutions.required
                  "
                >
                  {{ $t("users.validations.institution.required") }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col
              lg="6"
              md="6"
              sm="12"
              xl="6"
              v-if="form.role_id && form.role_id === 4"
            >
              <b-form-group :label="$t('users.branch')">
                <multiple-select-input
                  :disabled="!form.institutions || !form.institutions.length"
                  :model.sync="form.branches"
                  :values="branches"
                  :multiple="false"
                  :max="1"
                  label="name"
                  track-by="id"
                ></multiple-select-input>
                <b-form-invalid-feedback
                  v-if="
                    !validateState('branches') && !$v.form.branches.required
                  "
                  :state="
                    validateState('branches') && $v.form.branches.required
                  "
                >
                  {{ $t("users.validations.branch.required") }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <template v-if="form.id && form.current_photo">
              <b-col lg="3" md="3" sm="12" xl="3">
                <img
                  :src="form.current_photo"
                  class="img-fluid img-thumbnail"
                />
                <div class="text-center">
                  <b-btn
                    class="btn-icon mt-2 text-white w-100"
                    variant="danger"
                    @click="deleteFile()"
                    ><i class="bx bx-trash"></i>
                  </b-btn>
                </div>
              </b-col>
            </template>

            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('users.status')">
                <b-form-checkbox
                  v-model="form.status"
                  name="check-button"
                  switch
                >
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col
              class="float-right text-right"
              lg="12"
              md="12"
              sm="12"
              xl="12"
            >
              <b-button
                class="mr-1 text-white"
                variant="secondary"
                @click="goBack"
              >
                <i class="fas fa-arrow-left"></i>
                {{ $t("general.cancel") }}
              </b-button>
              <b-button variant="primary" @click="createOrUpdate()">
                <i class="far fa-save"></i>
                {{ $t(id != null ? "general.save" : "general.create") }}
              </b-button>
            </b-col>
          </b-row>
        </template>
      </dashboard-box>
    </div>
  </div>
</template>
<script>
import DashboardBox from "@/assets/components/DashboardBox";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

import baseModule, {
  BASE_URL,
  CREATE_ITEM,
  ERROR,
  GET_ITEM,
  ITEM,
  LOADING,
  MODULE_NAME,
  SUCCESS,
  UPDATE_ITEM,
  GET_PHOTO,
  UPLOAD_PHOTO,
  DELETE_PHOTO,
  PHOTO,
} from "@/core/services/store/user.module";

import institutionModule, {
  ITEMS_ALL as INSTITUTION_ITEMS,
  MODULE_NAME as INSTITUTION_MODULE,
  GET_ALL_ITEMS as GET_INSTITUTION_ITEMS,
} from "@/core/services/store/institution.module";

import branchModule, {
  ITEMS_ALL as BRANCH_ITEMS,
  MODULE_NAME as BRANCH_MODULE,
  GET_ALL_ITEMS as GET_BRANCH_ITEMS,
} from "@/core/services/store/branch.module";

import roleModule, {
  ITEMS_ALL as ROLE_ITEMS,
  MODULE_NAME as ROLE_MODULE,
  GET_ALL_ITEMS as GET_ROLE_ITEMS,
} from "@/core/services/store/role.module";

import teamTypeModule, {
  ITEMS_ALL as TEAM_TYPE_ITEMS,
  MODULE_NAME as TEAM_TYPE_MODULE,
  GET_ALL_ITEMS as GET_TEAM_TYPE_ITEMS,
} from "@/core/services/store/teamType.module";

import regionModule, {
  ITEMS_ALL as REGION_ITEMS,
  MODULE_NAME as REGION_MODULE,
  GET_ALL_ITEMS as GET_REGION_ITEMS,
} from "@/core/services/store/region.module";

import store from "@/core/services/store";
import { validationMixin } from "vuelidate";
import { email, required, sameAs, requiredIf } from "vuelidate/lib/validators";
import MultipleSelectInput from "@/assets/components/inputs/MultipleSelectInput";
import _ from "lodash";
import passwordComplexity from "@/assets/components/customValidators/passwordComplexity";

const _MODULE_NAME = MODULE_NAME;
const _INSTITUTION_MODULE = INSTITUTION_MODULE;
const _BRANCH_MODULE = BRANCH_MODULE;
const _ROLE_MODULE = ROLE_MODULE;
const _TEAM_TYPE_MODULE = TEAM_TYPE_MODULE;
const _REGION_MODULE = REGION_MODULE;

export default {
  name: "UsersCreateEdit",
  mixins: [validationMixin],
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_MODULE_NAME, baseModule);
    registerStoreModule(_INSTITUTION_MODULE, institutionModule);
    registerStoreModule(_BRANCH_MODULE, branchModule);
    registerStoreModule(_ROLE_MODULE, roleModule);
    registerStoreModule(_TEAM_TYPE_MODULE, teamTypeModule);
    registerStoreModule(_REGION_MODULE, regionModule);
  },
  components: {
    DashboardBox,
    MultipleSelectInput,
  },
  validations: {
    form: {
      name: {
        required,
      },
      surname: {
        required,
      },
      password: {
        required: requiredIf(function () {
          return !this.id;
        }),
        passwordComplexity,
      },
      password_confirmation: {
        required: requiredIf(function () {
          return !this.id;
        }),
        sameAsPassword: sameAs("password"),
      },
      title: {
        required,
      },
      work_number: {
        required,
      },
      photo: {
        required: requiredIf(function () {
          return !this.id;
        }),
      },
      phone_number: {
        required,
      },
      email: {
        required,
        email,
      },
      status: {
        required,
      },
      branches: {
        required: requiredIf(function () {
          return this.form.role_id && this.form.role_id === 4;
        }),
      },
      institutions: {
        required: requiredIf(function () {
          return this.form.role_id && this.form.role_id === 4;
        }),
      },
      team_types: {
        required: requiredIf(function () {
          return this.form.role_id && this.form.role_id === 3;
        }),
      },
      regions: {
        required: requiredIf(function () {
          return this.form.role_id && this.form.role_id === 3;
        }),
      },
      role_id: {
        required,
      },
    },
  },
  computed: {
    error() {
      return store.getters[_MODULE_NAME + "/" + ERROR];
    },
    loading() {
      return store.getters[_MODULE_NAME + "/" + LOADING];
    },
    success() {
      return store.getters[_MODULE_NAME + "/" + SUCCESS];
    },
    item() {
      return store.getters[_MODULE_NAME + "/" + ITEM];
    },
    institutions() {
      return store.getters[_INSTITUTION_MODULE + "/" + INSTITUTION_ITEMS] || [];
    },
    branches() {
      return store.getters[_BRANCH_MODULE + "/" + BRANCH_ITEMS] || [];
    },
    roles() {
      return store.getters[_ROLE_MODULE + "/" + ROLE_ITEMS] || [];
    },
    teamTypes() {
      return store.getters[_TEAM_TYPE_MODULE + "/" + TEAM_TYPE_ITEMS] || [];
    },
    regions() {
      return store.getters[_REGION_MODULE + "/" + REGION_ITEMS] || [];
    },
    photo() {
      return store.getters[_MODULE_NAME + "/" + PHOTO] || [];
    },
  },
  data() {
    return {
      id: this.$route.params.id,
      form: {
        name: null,
        surname: null,
        title: null,
        work_number: null,
        photo: null,
        phone_number: null,
        email: null,
        password: null,
        password_confirmation: null,
        status: true,
        role_id: null,
        institutions: [],
        branches: [],
        team_types: [],
        regions: [],
      },
    };
  },
  methods: {
    goBack() {
      this.$router.push({ name: "management.users" });
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    getItem() {
      this.$store.dispatch(_MODULE_NAME + "/" + GET_ITEM, {
        url: BASE_URL + "/" + this.id,
      });
    },
    getInstitutions() {
      this.$store.dispatch(
        _INSTITUTION_MODULE + "/" + GET_INSTITUTION_ITEMS,
        {}
      );
    },
    getBranches() {
      let institution = this.form.institutions;
      if (!institution) return false;
      let filter = {
        institution_id: institution,
      };
      this.$store.dispatch(_BRANCH_MODULE + "/" + GET_BRANCH_ITEMS, {
        filters: filter,
      });
    },
    getRoles() {
      this.$store.dispatch(_ROLE_MODULE + "/" + GET_ROLE_ITEMS, {});
    },
    getTeamTypes() {
      this.$store.dispatch(_TEAM_TYPE_MODULE + "/" + GET_TEAM_TYPE_ITEMS, {});
    },
    getRegions() {
      this.$store.dispatch(_REGION_MODULE + "/" + GET_REGION_ITEMS, {});
    },
    uploadFile(e) {
      let file = e.target.files[0];
      this.form.photo = file;

      if (this.id && file) {
        let self = this;
        let form = new FormData();
        form.append("photo", file);
        let url = BASE_URL + "/" + this.id + "/photo";
        this.$store
          .dispatch(_MODULE_NAME + "/" + UPLOAD_PHOTO, {
            url: url,
            contents: form,
          })
          .then((response) => {
            if (response.status) {
              setTimeout(() => {
                self.sweetAlertSuccess(response.data.message).then(() => {
                  self.$store.dispatch(_MODULE_NAME + "/" + GET_PHOTO, {
                    url: url,
                  });
                });
              }, 200);
            }
          });
      }
    },
    deleteFile() {
      let self = this;
      this.sweetAlertConfirm(this.$t("general.are_you_sure"), function (self) {
        let url = BASE_URL + "/" + self.id + "/photo";
        self.$store
          .dispatch(_MODULE_NAME + "/" + DELETE_PHOTO, {
            url: url,
          })
          .then((response) => {
            if (response.status) {
              setTimeout(() => {
                self.sweetAlertSuccess(response.data.message).then(() => {
                  url = BASE_URL + "/" + self.id + "/photo";
                  self.$store.dispatch(_MODULE_NAME + "/" + GET_PHOTO, {
                    url: url,
                  });
                });
              }, 100);
            }
          });
      });
    },
    createOrUpdate() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      let formData = _.clone(this.form);

      if (this.form.status) {
        formData.status = 1;
      } else {
        formData.status = 0;
      }

      formData.roles = [formData.role_id];

      formData.branches = [formData.branches];

      formData.team_types = [formData.team_types];

      formData.regions = [formData.regions];

      formData.institutions = [formData.institutions];

      let form = new FormData();
      form.append("name", this.form.name);
      form.append("surname", this.form.surname);
      form.append("email", this.form.email);
      form.append("title", this.form.title);
      form.append("phone_number", this.form.phone_number);
      form.append("work_number", this.form.work_number);

      if (this.form.role_id) {
        form.append("roles[]", [this.form.role_id]);
      }

      if (this.form.team_types) {
        form.append("team_types[]", [this.form.team_types]);
      }

      if (this.form.regions) {
        form.append("regions[]", [this.form.regions]);
      }

      if (this.form.password) {
        form.append("password", this.form.password);
        form.append("password_confirmation", this.form.password);
      }

      if (this.form.status) {
        form.append("status", 1);
      } else {
        form.append("status", 0);
      }

      if (this.form.branches && this.form.branches.length) {
        let branchIds = _.map(this.form.branches, "id");
        form.append("branches[]", branchIds);
      }

      if (this.form.photo !== null) {
        form.append("photo", this.form.photo);
      }

      if (this.id) {
        this.$store.dispatch(_MODULE_NAME + "/" + UPDATE_ITEM, {
          url: BASE_URL + "/" + this.id,
          contents: formData,
        });
      } else {
        this.$store.dispatch(_MODULE_NAME + "/" + CREATE_ITEM, {
          url: BASE_URL,
          contents: form,
        });
      }
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t("general.dashboard"), route: "dashboard" },
      { title: this.$t(this.id ? "users.edit_item" : "users.create_item") },
    ]);

    if (this.institutions && !this.institutions.length) {
      this.getInstitutions();
    }

    if (this.roles && !this.roles.length) {
      this.getRoles();
    }

    if (this.teamTypes && !this.teamTypes.length) {
      this.getTeamTypes();
    }

    if (this.regions && !this.regions.length) {
      this.getRegions();
    }

    if (this.id) {
      this.getItem();
    }
  },
  watch: {
    "form.institutions": {
      handler: function (newValue, oldValue) {
        if (newValue === null) return;
        this.getBranches();
      },
    },
    institutions: {
      handler(newValue, oldValue) {
        if (newValue) {
          if (newValue.length) {
            if (this.form && typeof this.form.institution_id !== "object") {
              this.form.institution_id = this.institutions.find(
                (subItem) => +subItem.id === +this.form.institution_id
              );
            }
          }
        }
      },
      deep: true,
    },
    branches: {
      handler(newValue, oldValue) {
        if (newValue) {
          if (newValue.length) {
            if (this.form && typeof this.form.branch_id !== "object") {
              this.form.branch_id = this.branches.find(
                (subItem) => +subItem.id === +this.form.branch_id
              );
            }
          }
        }
      },
      deep: true,
    },
    item(value) {
      if (value) {
        let item = _.clone(value);

        if (item.status) {
          item.status = true;
        } else {
          item.status = false;
        }

        if (item.roles && item.roles.length) {
          item.role_id = item.roles[0].id;
        }

        if (item.team_types && item.team_types.length) {
          item.team_types = item.team_types[0].id;
        }

        if (item.regions && item.regions.length) {
          item.regions = item.regions[0].id;
        }

        if (item.branches && item.branches.length) {
          item.branches = item.branches[0].id;
        }

        if (item.institutions && item.institutions.length) {
          item.institutions = item.institutions[0].id;
        }


        if (item.id) {
          this.id = item.id;
          item.photo = null;
          item.current_photo = item.photo_link;
        }
        this.form = item;
      }
    },
    photo(item) {
      if (item) {
        this.form.current_photo = null;
        this.form.current_photo = _.clone(item);
        this.form.photo = null;
      }
    },
    success(value) {
      let self = this;
      if (value) {
        setTimeout(() => {
          self.sweetAlertSuccess(
            self.$t("general.successfully_saved"),
            (response) => {
              if (response) {
                self.$router.push({ name: "management.users" });
              }
            }
          );
        }, 500);
      }
    },
  },
};
</script>

<style scoped>
#dashboard-box {
  padding: 10px;
}
</style>
